import { CHAT_MESSAGE_FAILED_REASONS } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { ChatMessagesTableDefinitionZod } from '../tables';

type Arguments = {
    chatId: string;
    limit?: number;
    // sequence cursor (not offset) — collision-free while messages arrive.
    before?: number;
    after?: number;
};

// Unknown failureReason (FE bundle older than manta) degrades to META_API_ERROR instead of failing the whole page.
export const schemaChatResolver_GetMessages = z.array(
    ChatMessagesTableDefinitionZod.extend({
        failureReason: ChatMessagesTableDefinitionZod.shape.failureReason.catch(
            CHAT_MESSAGE_FAILED_REASONS.META_API_ERROR,
        ),
    }),
);

export type SchemaChatResolver_GetMessages = z.infer<typeof schemaChatResolver_GetMessages>;

export type ChatResolver_GetMessages = Resolver<Arguments, SchemaChatResolver_GetMessages>;
